"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var Event = {
    /* Note: If not using handleRcIframe, one can just listen to oprg_GamePause and oprg_GameResume postMessages instead.
    But if handleRcIframe is used, rcinterval pause will not post oprg_GamePause */

    /* If this event is received, and once any unfinished round has completed, the game must disable controls,
    pause autoplay, and call reportPaused() once the game is idle */
    PAUSE_REQUESTED: 'rg_pause',

    /* Re-enable controls and resume autoplay if paused by rg feature */
    RESUME: 'rg_resume',

    /* The game does not need to handle these two */
    PAUSE: 'rg_pauseComplete',
    WARN: 'rg_pauseWarn',
    UPDATE_BALANCE: 'rg_updateBalance'
};
var States = {
    NOT_PAUSED: 0,
    PAUSE_PENDING: 1,
    PAUSE_REPORT_PENDING: 2,
    PAUSED: 3
};
var pausedState = States.NOT_PAUSED;
var pausePayload; // CustomEvent polyfill

(function () {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();

function requestPause(payload) {
    if (pausedState === States.PAUSED) {
        warn('Already paused');
    } else if (pausedState === States.PAUSE_PENDING) {
        warn('Pause already requested, waiting for the current round to end');
    }

    pausedState = States.PAUSE_PENDING;
    pausePayload = payload;
    var event = new CustomEvent(Event.PAUSE_REQUESTED);
    event.data = payload;
    window.dispatchEvent(event);
}

function paused(sessionStats) {
    pausedState = States.PAUSED;
    var event = new CustomEvent(Event.PAUSE);

    if (sessionStats) {
        if (pausePayload) {
            pausePayload.sessionresult = sessionStats;
        } else {
            pausePayload = {
                sessionresult: sessionStats
            };
        }
    }

    event.data = pausePayload;
    window.dispatchEvent(event);
    pausePayload = null;
}

function resume(payload) {
    if (pausedState === States.NOT_PAUSED) {
        warn('Requesting resume, but the game is not paused');
    }

    pausedState = States.NOT_PAUSED;
    var event = new CustomEvent(Event.RESUME);
    event.data = payload;
    window.dispatchEvent(event);
}

function warn(message) {
    var event = new CustomEvent(Event.WARN);
    event.message = message;
    window.dispatchEvent(event);
}

function updateBalance() {
    var event = new CustomEvent(Event.UPDATE_BALANCE);
    window.dispatchEvent(event);
}

var Events = {
    Event: Event,
    requestPause: requestPause,
    paused: paused,
    resume: resume,
    updateBalance: updateBalance
};

function getEventDataPayload(data) {
    if (!data || !data.payload) {
        return null;
    }

    if (typeof data.payload === 'string') {
        return JSON.parse(data.payload);
    }

    return data.payload;
}

function UrlParams(url) {
    var _this = this;

    this.vars = {};
    this.length = 0;
    decodeURIComponent(url).replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        _this.vars[key] = value;
        _this.length++;
    });
}

UrlParams.prototype = {
    isEmpty: function isEmpty() {
        return this.length === 0;
    },
    get: function get(key) {
        if (this.vars[key]) {
            return this.vars[key];
        }

        return null;
    },
    has: function has(key) {
        if (this.vars[key]) {
            return true;
        }

        return false;
    },
    append: function append(key, value) {
        if (this.vars[key] === undefined) {
            this.length++;
        }

        this.vars[key] = value;
    }
};
var Tools = {
    getEventDataPayload: getEventDataPayload,
    UrlParams: UrlParams
};

function RcDomElement(urlParams) {
    if (!urlParams.has('rciframeurl')) {
        return {
            error: 'Error creating RC:rciframeurl is not defined'
        };
    }

    var urlString = urlParams.get('rciframeurl');

    if (!urlString || urlString === '') {
        return {
            error: "RC iFrame URL defined but invalid: ".concat(urlString, "}")
        };
    } // IE doesn't support URL/URLSearchParams


    var params = new Tools.UrlParams(urlString);

    if (params.isEmpty()) {
        urlString += '?';
    } else {
        urlString += '&';
    }

    urlString += "rchistoryurl=".concat(urlParams.get('rchistoryurl'), "&homeurl=").concat(urlParams.get('homeurl'));
    var iframeId = 'rg_rc_iframe';
    var element = document.getElementById(iframeId);

    if (!element) {
        element = document.createElement('iframe');
        element.src = urlString;
        element.id = iframeId;
        element.style.display = 'none';
        element.style.position = 'fixed';
        element.style.left = 0;
        element.style.top = 0;
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.zIndex = 1001;
        element.frameBorder = 0;
        var wrapper = document.getElementById('rc_iframe_wrapper');

        if (wrapper) {
            wrapper.appendChild(element);
        } else {
            document.body.appendChild(element);
        }
    }

    return element;
}

function ClientInterval(urlParams) {
    if (!urlParams.has('rcinterval')) {
        // rcenable is true, but rcinterval is not defined - RC must be triggered by the operator');
        return false;
    }

    var rcinterval = Number(urlParams.get('rcinterval'));

    if (isNaN(rcinterval)) {
        return {
            error: "Error creating RC interval: Invalid rcinterval parameter ".concat(rcinterval)
        };
    }

    if (rcinterval <= 0) {
        // RC parameters are defined, but RC is disabled because rcinterval is 0
        return false;
    }

    var startTimeMs = Date.now();
    var initialRcElapsed = Number(urlParams.get('rcelapsed')) || 0;
    var nextRcTriggerSeconds = !initialRcElapsed ? rcinterval : rcinterval - initialRcElapsed % rcinterval;
    setTimeout(triggerRealityCheckTime, nextRcTriggerSeconds * 1000);

    function triggerRealityCheckTime() {
        var totalElapsed = initialRcElapsed + Math.round((Date.now() - startTimeMs) / 1000);
        Events.requestPause({
            realityCheck: true,
            sessionTime: totalElapsed
        });
        setTimeout(triggerRealityCheckTime, rcinterval * 1000);
    }

    return true;
}

var rciframe;
/*
 * The reality check will work in standalone mode, without operator utilizing the PostMessage API.
 * Enabled if the game gives rciframeurl as an init parameter and &rcenable is false.
 */

var standAloneMode = false;
var errors = []; // Legacy API methods relayed to the rc iframe

var OPERATOR_METHODS = ['gameLoaded', 'gameLoadedHandler', 'gamePausedHandler', 'playTimeHandler', 'handshakeSuccess', 'handshakeCompleted', 'handshakeFail', 'handshakeFailed'];

function init(params) {
    var urlParams = new Tools.UrlParams(document.location.href);

    function log(text, color) {
        if (urlParams.get('showrgdebuglog')) {
            // eslint-disable-next-line no-console
            console.log("%c".concat(text), color);
        }
    } // Default rciframeurl


    if (urlParams.get('rcenable') !== 'true') {
        if (params && params.rciframeurl && urlParams.get('rcinterval')) {
            /**
             * rcenable is false but a default rciframeurl and interval found:
             * operator post API is not enabled, but the game uses this lib for
             * reality check popup
             */
            log('RgAPI handles RC (standalone mode)', 'background: #222; color: #bada55');
            standAloneMode = true;
            urlParams.append('rciframeurl', params.rciframeurl);
        } else {
            /*
            * rcenable is false and no default rciframeurl and interval:
            * the game ifself must handle the reality check popup
            */
            log('Game handles reality check', 'background: #ff00f0; color: #ffffff');
            return;
        }
    } else {
        log('RgAPI handles RC (operator mode)', 'background: #222; color: #bada55');
    }

    rciframe = RcDomElement(urlParams);

    if (rciframe.error) {
        addError(rciframe.error);
        return;
    }

    var interval = ClientInterval(urlParams);

    if (interval.error) {
        addError(interval.error);
    }

    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;

        if (data && data.realityCheck) {
            open(data);
        }
    });
    window.addEventListener(Events.Event.RESUME, function (event) {
        var data = event.data;

        if (data && data.realityCheck) {
            close();
        }
    });
}

function addError(errorMessage) {
    errors.push(errorMessage);
}

function close() {
    if (!rciframe) {
        return;
    }

    rciframe.style.display = 'none';
}

function open(data) {
    if (!rciframe) {
        return;
    }

    if (standAloneMode && data && rciframe.contentWindow) {
        // Send reality check data when PostAPI is not enabled
        rciframe.contentWindow.postMessage({
            rgMessage: 'gprg_RealityCheckData',
            payload: data
        }, '*');
    }

    rciframe.style.display = 'block';
}

function handlePostMessage(data) {
    if (isForOperator(data) === false) {
        return;
    }

    if (rciframe && rciframe.contentWindow) {
        rciframe.contentWindow.postMessage(data, '*');
    }
}

function isForOperator(data) {
    if (!data) {
        return false;
    }

    if (data.rgMessage && data.rgMessage.indexOf('gprg_') === 0) {
        return true;
    }

    if (data.method && OPERATOR_METHODS.indexOf(data.method) >= 0) {
        return true;
    }

    return false;
}

var ExternalRealityCheck = {
    init: init,
    handlePostMessage: handlePostMessage,
    getErrors: function getErrors() {
        return errors;
    }
};
var isGameLoaded = false;
var sessionConstants = null;
var isEnabled = false;
var isListeningPauseEvents = false;

function init$1(params) {
    var urlParams = new Tools.UrlParams(document.location.href);

    if (urlParams.get('rcenable') !== 'true') {
        return;
    }

    isEnabled = true;

    if (params) {
        sessionConstants = params.sessionData;
    }
}

function addListeners() {
    if (isListeningPauseEvents) {
        return;
    }

    isListeningPauseEvents = true;
    window.addEventListener(Events.Event.PAUSE_REQUESTED, function (event) {
        var data = event.data;

        if (data && data.sessionTime) {
            post('playTimeHandler', {
                delay: data.sessionTime
            });
        }
    });
    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;

        if (!data.returnData) {
            // Pause triggered by clientInterval
            post('gamePausedHandler');
            return;
        } // Requested callback with any return data


        post(data.returnData.method, data.returnData.params);
    });
}

var callbacks = {
    operatorLoaded: function operatorLoaded() {
        // Report gameLoaded if the operator wasn't ready before
        if (isGameLoaded) {
            reportGameReady();
        }
    },
    confirmHandshake: function confirmHandshake(params) {
        addListeners();
        post(params.success);
    },
    pauseGame: function pauseGame(params) {
        var payload = {
            realityCheck: true
        };

        if (params.callback) {
            payload.returnData = {
                method: params.callback,
                params: buildPauseReturnData(params)
            };
        }

        Events.requestPause(payload);
    },
    resumeGame: function resumeGame() {
        Events.resume({
            realityCheck: true
        });
    },
    navigateTo: function navigateTo(params) {
        if (params && params.url) {
            window.location.href = params.url;
        }
    }
};

function post(method, params) {
    if (!isEnabled) {
        return;
    }

    var message = {
        method: method,
        params: params
    };
    window.parent.postMessage(message, '*');
    ExternalRealityCheck.handlePostMessage(message);
}

function buildPauseReturnData(params) {
    if (!sessionConstants) {
        return {};
    }

    var dataToReturn = {};

    if (params.return_data) {
        params.return_data.forEach(function (element) {
            dataToReturn[element] = sessionConstants[element];
        });
    }

    return JSON.stringify(dataToReturn);
}

function handlePostMessage$1(data) {
    if (!isEnabled) {
        return;
    }

    if (!data || !data.method) {
        return;
    }

    var fn = callbacks[data.method];
    var parameters;

    if (data.params) {
        parameters = data.params;
    }

    if (typeof fn === 'function') {
        fn(parameters);
    }
}

function reportGameReady() {
    isGameLoaded = true;
    post('gameLoadedHandler');
}

var LegacyAPI = {
    init: init$1,
    reportGameReady: reportGameReady,
    handlePostMessage: handlePostMessage$1,
    disable: function disable() {
        isEnabled = false;
    }
};
var version = "1.3.0";
var TARGET_ORIGIN = '*';
var isEnabled$1 = false;
var isListeningPauseEvents$1 = false;

function handlePostMessage$2(data) {
    if (!isEnabled$1) {
        return;
    }

    if (!data) {
        return;
    }

    if (!data.rgMessage) {
        return;
    }

    if (data.rgMessage.indexOf('oprg_') === -1) {
        return;
    }

    var payload = Tools.getEventDataPayload(data);

    switch (data.rgMessage) {
        case 'oprg_Ready':
            addPauseEventListeners();
            LegacyAPI.disable(); // Reporting that we are ready to receive messages...

            post$1('gprg_Ready');
            break;

        case 'oprg_GamePause':
            Events.requestPause(payload); // gprg_GamePaused will be sent once the round is finished

            break;

        case 'oprg_GameResume':
            Events.resume(payload);
            break;

        case 'oprg_NavigateGame':
            if (payload && payload.url) {
                window.location.href = payload.url;
            } else {
                warn$1('Missing payload.url');
            }

            break;

        case 'oprg_DebugSettings':
            post$1('gprg_DebugSettings', {
                id: "RgPostMessageAPI v".concat(version)
            });
            break;

        case 'oprg_DebugErrors':
            // Only reality check can have reportable errors atm.
            post$1('gprg_DebugErrors', ExternalRealityCheck.getErrors(), '*');
            break;

        case 'oprg_Ping':
            if (payload && payload.id) {
                post$1('gprg_Pong', {
                    id: payload.id
                });
            } else {
                post$1('gprg_Pong');
            }

            break;

        case 'oprg_UpdateBalance':
            Events.updateBalance();
            break;

        default:
            warn$1("Unknown rgMessage ".concat(data.rgMessage));
    }
}

function addPauseEventListeners() {
    if (isListeningPauseEvents$1) {
        return;
    }

    isListeningPauseEvents$1 = true;
    window.addEventListener(Events.Event.PAUSE_REQUESTED, function (event) {
        var data = event.data;

        if (data && data.sessionTime) {
            post$1('gprg_RealityCheckData', {
                sessionTime: data.sessionTime
            });
        }
    });
    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;
        post$1('gprg_GamePaused', data);
    });
    window.addEventListener(Events.Event.RESUME, function (event) {
        var data = event.data;
        post$1('gprg_GameResumed', data);
    });
    window.addEventListener(Events.Event.WARN, function (event) {
        var message = event.message;

        if (message) {
            warn$1(message);
        }
    });
}
/**
 * @param {string} rgMessage - message identifier
 * @param {Object} payload - message payload as an Object
 */


function post$1(rgMessage, payload) {
    if (!isEnabled$1) {
        return;
    }

    if (!rgMessage) {
        return;
    }

    var message = {
        rgMessage: rgMessage,
        payload: payload
    };
    window.parent.postMessage(message, TARGET_ORIGIN);
    ExternalRealityCheck.handlePostMessage(message);
}

function warn$1(warningMessage) {
    post$1('gprg_Warning', {
        message: warningMessage
    });
}

var PostAPI = {
    init: function init() {
        isEnabled$1 = true;
        post$1('gprg_Listening');
    },
    reportGameReady: function reportGameReady() {
        post$1('gprg_GameReady');
    },
    userAction: function userAction(action) {
        post$1('gprg_UserAction', {
            action: action
        });
    },
    gameRoundStarted: function gameRoundStarted() {
        post$1('gprg_GameRoundStart');
    },
    gameRoundEnded: function gameRoundEnded() {
        post$1('gprg_GameRoundEnd');
    },
    handlePostMessage: handlePostMessage$2
};

function CreatePauseModal() {
    var element = document.getElementById('rg_pause_modal');

    if (!element) {
        element = document.createElement('div');
        element.id = 'rg_pause_modal';
        element.style.position = 'fixed';
        element.style.left = 0;
        element.style.top = 0;
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        element.style.display = 'none';
        element.style.zIndex = 1000;

        var _rciframe = document.getElementById('rg_rc_iframe');

        if (_rciframe) {
            _rciframe.parent.insertBefore(element, _rciframe);
        } else {
            var wrapper = document.getElementById('rc_iframe_wrapper');

            if (wrapper) {
                wrapper.appendChild(element);
            } else {
                document.body.appendChild(element);
            }
        }
    }

    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;

        if (data && data.autoPlayOnly) {
            return;
        }

        element.style.display = 'block';
    });
    window.addEventListener(Events.Event.RESUME, function (event) {
        var data = event.data;

        if (data && data.autoPlayOnly) {
            return;
        }

        element.style.display = 'none';
    });
}
/**
 * @param {Boolean} bHandleRcIframe - If an iframe for rciframeurl is handled automatically.
 * @param {Object} sessionData - Data needed if supporting the old API {session_id:string, game_name:string, user_id:string}
 * @param {Object} params {rciframeurl: string} - Additional init data. If params.rciframeurl and &interval URL parameter are
 * set, this lib will handle showing the RC popup even if &rcenable is false
 */


function init$2(bHandleRcIframe, sessionData, params) {
    PostAPI.init();
    LegacyAPI.init(sessionData);
    CreatePauseModal();

    if (bHandleRcIframe) {
        ExternalRealityCheck.init(params);
    }

    window.addEventListener('message', onPostMessage);
}

function onPostMessage(event) {
    var data = event.data;

    if (!data) {
        return;
    }

    PostAPI.handlePostMessage(data);
    LegacyAPI.handlePostMessage(data);
    ExternalRealityCheck.handlePostMessage(data);
} // When game is loaded and ready


function reportGameReady$1() {
    PostAPI.reportGameReady();
    LegacyAPI.reportGameReady();
}
/**
 * Called by the game to report the game as paused
 * @param {*} sessionStats Session stats needed for some jurisdictions, needs to be reported by
 * the game here using this lib for RC without the operator (init params.rciframeurl is defined).
 * If given here, the data will be passed to the rc iframe with a gprg_RealityCheckData postMessage,
 * in event.data.sessionresult
 */


function reportPaused(sessionStats) {
    Events.paused(sessionStats);
}

function userAction(action) {
    var prefix = 'action:';

    if (action.indexOf(prefix) === 0) {
        // We are inside a wrapper - send postMessage navigate request instead
        var url = action.slice(prefix.length);
        PostAPI.userAction(url);
        return;
    }

    window.location = action;
}

var RgPostMessageAPI = {
    init: init$2,
    reportGameReady: reportGameReady$1,
    reportPaused: reportPaused,
    userAction: userAction,
    gameRoundStarted: PostAPI.gameRoundStarted,
    gameRoundEnded: PostAPI.gameRoundEnded,
};
exports.RgPostMessageAPI = RgPostMessageAPI;



//////////////////
// WEBPACK FOOTER
// ./relax/RgPostMessageAPI.esm.js
// module id = 629
// module chunks = 0